import axios from "axios";

//const API = "https://localhost:8443/api/inventaires";
const API = "https://app.bicadev.com/api/inventaires";
export const inventaireApi = {

  create: (username, type = "GENERAL", depotId = null) =>
    axios.post(API, null, {
      params: { username, type, depotId }
    }),

  start: (id, username) =>
    axios.post(`${API}/${id}/start`, null, {
      params: { username }
    }),

  scan: (id, numeroRouleau, username) =>
    axios.post(`${API}/${id}/scan`,
      { numeroRouleau },
      { params: { username } }
    ),

  getStatus: (id) =>
    axios.get(`${API}/${id}/status`),

  getLignesPage: (id, page = 0, size = 20, sort = "scanDate", dir = "desc") =>
    axios.get(`${API}/${id}/lignes`, { params: { page, size, sort, dir } }),
  // ================= LIST =================
  getById: (id) =>
    axios.get(`${API}/${id}`),
  getAll: () =>
    axios.get(API),

  validate: (id, username) =>
    axios.post(`${API}/${id}/validate`, null, {
      params: { username }
    })
};